import notificationService from "../../../services/NotificationService";
import ManualApprovalDisplayLogicDashboard from "./dashboard/manualApprovalDisplayLogicDashboard.js";
import ManualApprovalDisplayLogicSettings from "./settings/manualApprovalDisplayLogicSettings.js";
import LoadingDisplay from "../../common/LoadingDisplay/LoadingDisplay.js";
import { useState } from "react";

const ManualApprovalLogic = ({
    getSettings,
    updateUserSettings,
    approveOrDenyMeme,
    currentMeme,
    browserSourceIsActive,
    remotelyApprovedby,
    applicationDisplayLocation,
    setIsApiCallInProgress,
    isApiCallInProgress,
    isBlueToggleClickable,
    setIsBlueToggleClickable,
    title,
    isDashboard,
}) => {
    const [isLoading, setIsLoading] = useState(false);

    // disables or enables manual approval on settings
    const approvalToggleLogic = async () => {
        if (!isBlueToggleClickable) return;
        setIsLoading(true);
        setIsBlueToggleClickable(false);
        await updateUserSettings({
            manualApproval: !getSettings().manualApproval,
        });
        setIsBlueToggleClickable(true);
        setIsLoading(false);
    };

    // Button logic that is passing along the current meme
    const onButtonClick = async (state) => {
        if (!currentMeme) {
            console.error("approveAndDenyButton", state, currentMeme);
            // we should only hit this in development
            notificationService.setMessage("There was no meme! :O ");
            return;
        }

        setIsApiCallInProgress(true);
        setIsLoading(true);

        if (state === "APPROVE")
            await approveOrDenyMeme(currentMeme, "APPROVE");
        else await approveOrDenyMeme(currentMeme, "DENY");

        setIsLoading(false);
        setIsApiCallInProgress(false);
    };

    // Component switch based on page
    let displayComponent = (
        <ManualApprovalDisplayLogicDashboard
            getSettings={getSettings}
            currentMeme={currentMeme}
            browserSourceIsActive={browserSourceIsActive}
            remotelyApprovedby={remotelyApprovedby}
            onButtonClick={onButtonClick}
            isApiCallInProgress={isApiCallInProgress}
            title={title}
        />
    );

    if (applicationDisplayLocation === "settings") {
        displayComponent = (
            <ManualApprovalDisplayLogicSettings
                getSettings={getSettings}
                currentMeme={currentMeme}
                browserSourceIsActive={browserSourceIsActive}
                remotelyApprovedby={remotelyApprovedby}
                onButtonClick={onButtonClick}
                isApiCallInProgress={isApiCallInProgress}
                approvalToggleLogic={approvalToggleLogic}
            />
        );
    }

    const loadingDisplay = (
        <div
            className={
                isDashboard
                    ? "LoadingDisplayManualApprovalDashboard"
                    : "LoadingDisplayManualApproval"
            }
        >
            <LoadingDisplay invert={true} />
        </div>
    );

    return isLoading ? loadingDisplay : displayComponent;
};

export default ManualApprovalLogic;
